import { IconPlayCircle, Spacing } from '@kezios/design-system';
import { Button, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { LinkWithQueryParams } from 'components/website/components/atoms/LinkWithQueryParams/LinkWithQueryParams';
import { YoutubeModal } from 'components/website/components/modals/YoutubeModal/YoutubeModal';
import { TrialDecoration } from 'components/website/components/molecules/TrialDecoration/TrialDecoration';
import { useTranslations } from 'next-intl';

export type FeatureHeroCtaProps = {
  demoUrl?: string;
  demoTitle?: string;
  currentLocale: string;
};

export const FeatureHeroCta = ({
  demoUrl,
  demoTitle,
  currentLocale,
}: FeatureHeroCtaProps) => {
  const [modalOpened, { toggle }] = useDisclosure(false);
  const t = useTranslations('section.hero.cta');

  return (
    <>
      {modalOpened && demoUrl && demoTitle && (
        <YoutubeModal
          isOpen={modalOpened}
          onClose={() => toggle()}
          youtubeUrl={demoUrl}
          title={demoTitle}
        />
      )}
      <Flex
        style={{ position: 'relative' }}
        gap={Spacing.s3}
        align="center"
        justify="center"
      >
        {demoUrl && (
          <Button
            variant="oauth"
            w={'fit-content'}
            size="xl"
            leftSection={<IconPlayCircle size={24} color="gray.7" />}
            onClick={toggle}
          >
            <Text variant="textLg.semibold" c="gray.7">
              Demo
            </Text>
          </Button>
        )}
        <Button
          variant="filled"
          w={'fit-content'}
          size="xl"
          component={LinkWithQueryParams}
          locale={currentLocale}
          href="/download/"
        >
          {t('button')}
        </Button>
        <TrialDecoration />
      </Flex>
    </>
  );
};
